export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10867.8a094c17.jpg";